import { useTranslation } from 'react-i18next';
import { PersonOutlinedChip } from '../../../../../components/buttons/IconButtons';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 * @param {string} titleKey - Translation key used to render the label/title of the information item.
 * @param {string | number | React.ReactNode} value - The value/content displayed below the title.
 * @param {React.ReactNode} [icon] - Optional custom icon element. 
 * If not provided, a default <PersonOutlinedChip /> icon will be rendered.
 */
const InformationItem = ({ titleKey, value, icon }) => {
    const { t } = useTranslation();

    return (
        <div className='w-100'>
            <div className='d-flex align-items-start gap-3 px-3 mb-3'>
                <div className='p-8px border-radius-12px d-flex justify-content-center align-items-center w-44px h-44px background-success-100'>
                    {icon ? icon : <PersonOutlinedChip className='btn-icon-svg-24px' />}
                </div>
                <div className='row w-100'>
                    <div className='d-flex flex-column justify-content-center'>
                        <p className='ibl-font-w-600 fs-12px font-color-general-950 mb-1'>{t(titleKey)}</p>
                        <p className='ibl-font-w-400 fs-14px font-color-shades-800 m-0'>{value}</p>
                    </div>
                    <div className='m-0 mt-3'>
                        <div className='border-bottom-shades-300 mr-3 m-0 ' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InformationItem;
